import React from 'react';
import './style.css'

function CloseButtonIcon(props) {
  let s = props.size || 10
  let lineStyle = {
    strokeWidth: s / 3
  }
  return (
    <svg className="close-button-icon" width={s*2 + 'px'} height={s*2 + 'px'}>
      <g transform={`translate(${s},${s})rotate(45)`} onClick={props.clickHandler} >
        <rect x={-s} y={-s} width={s*2} height={s*2} />
        <line x1={-s} x2={s} style={lineStyle} />
        <line y1={-s} y2={s} style={lineStyle} />
      </g>
    </svg>
  );
}

export default CloseButtonIcon;



// WEBPACK FOOTER //
// ./src/CloseButtonIcon/index.js